module.exports = __webpack_public_path__ + "static/media/success.a29c170d.png";